(function() {
  var Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  exports.LocationService = (function(superClass) {
    extend(LocationService, superClass);

    function LocationService(http) {
      this.http = http;
      this.getCapacityUnit = bind(this.getCapacityUnit, this);
      this.initMarker = bind(this.initMarker, this);
      this.reset = bind(this.reset, this);
      this.createFeatureGroup = bind(this.createFeatureGroup, this);
      this.nameIsUnique = bind(this.nameIsUnique, this);
      this.createNew = bind(this.createNew, this);
      this.checkPlacement = bind(this.checkPlacement, this);
      this.save = bind(this.save, this);
      this.loadAllLocations = bind(this.loadAllLocations, this);
      this.setAllLocations = bind(this.setAllLocations, this);
      this.marker_placed = false;
      this.all_locations = null;
      this["new"] = null;
      this.invalid = {};
      this.icon = new L.mapbox.marker.icon({
        'marker-size': 'large',
        'marker-color': '#3A894C',
        'marker-symbol': 'farm'
      });
      this.initMarker();
    }

    LocationService.prototype.setAllLocations = function() {
      return this.loadAllLocations().then((function(_this) {
        return function(response) {
          return _this.all_locations = response.data.data;
        };
      })(this));
    };

    LocationService.prototype.loadAllLocations = function() {
      return this.http.post('backend/grower/buyer-location/load-all', {
        fpcResultId: this.params.fpcResultId
      });
    };

    LocationService.prototype.save = function(fpcResultId) {
      return this.http.post('backend/grower/buyer-location/save', {
        location: this["new"],
        fpcResultId: fpcResultId
      });
    };

    LocationService.prototype.checkPlacement = function(lat, lng) {
      return this.http.post('backend/grower/buyer-location/check-placement', {
        lat: lat,
        long: lng
      });
    };

    LocationService.prototype.createNew = function() {
      return this["new"] = {
        id: null,
        latitude: null,
        longitude: null,
        name: null,
        zip: null,
        admin_area_2_id: null
      };
    };

    LocationService.prototype.nameIsUnique = function(location_name) {
      var i, len, location, ref;
      ref = this.all_locations;
      for (i = 0, len = ref.length; i < len; i++) {
        location = ref[i];
        if (location.name.toLowerCase() === location_name.toLowerCase()) {
          return false;
        }
      }
      return true;
    };

    LocationService.prototype.createFeatureGroup = function() {
      if (this.feature_group) {
        App.map.removeLayer(this.feature_group);
      }
      delete this.feature_group;
      this.feature_group = new L.FeatureGroup();
      return this.feature_group.addTo(App.map);
    };

    LocationService.prototype.reset = function() {
      this.marker_placed = false;
      this.all_locations = null;
      this.invalid = {};
      this.createNew();
      this.createFeatureGroup();
      this.fromFpc = null;
      this.step = null;
      this.fpcResultId = null;
      this.existing = null;
      return this.editing = null;
    };

    LocationService.prototype.initMarker = function() {
      this.drawControl = new L.Control.MfMarker();
      App.map.addControl(this.drawControl);
      this.drawControl.deselect();
      return $('.leaflet-control-container').hide();
    };

    LocationService.prototype.getCapacityUnit = function() {
      return this.http.post('backend/grower/operation/get-capacity-unit');
    };

    return LocationService;

  })(Service);

}).call(this);
